import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: ${({ spaceBottom }) => spaceBottom}px;
  position: relative;

  .sticky-btn {
    display: block;
    width: 100%;
    max-width: 750px;
    border: 1px solid #326CF9;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const VideoWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: transparent;
  background-size: cover;
  position: relative;

  > video {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  > img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;

  > button {
    border: 0;
    background: transparent;
    position: absolute;
  }

  .outter {
    width: 28%;
    height: 2%;
    top: 39%;
    left: 36%;
  }

  .inner {
    width: 28%;
    height: 2%;
    top: 64.5555%;
    left: 36%;
  }

  .complex {
    width: 28%;
    height: 2%;
    top: 90.5555%;
    left: 36%;
  }

  .scroll-outter {
    width: 24%;
    height: 2%;
    top: 15.5%;
    left: 12%;
  }

  .scroll-inner {
    width: 24%;
    height: 2%;
    top: 15.5%;
    left: 38%;
  }

  .scroll-complex {
    width: 24%;
    height: 2%;
    top: 15.5%;
    left: 64%;
  }

  .outter-wrap {
    width: 100%;
    height: 23%;
    position: absolute;
    top: 18.9999%;
    left: 0;
  }

  .inner-wrap {
    width: 100%;
    height: 23%;
    position: absolute;
    top: 45%;
    left: 0;
  }

  .complex-wrap {
    width: 100%;
    height: 23%;
    position: absolute;
    top: 70.5%;
    left: 0;
  }
`;

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
`;

export const Modal = styled.div`
  width: 68vw;
  max-width: 520px;
  padding: 32px 32px 68px;
  background-color: #FFFFFF;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  > div.box {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;

    > h2 {
      display: flex;
      align-items: center;
      line-height: 32px;
      color: #292c3c;
      font-size: 16px;
      font-weight: 700;

      > img {
        margin-right: 8px;
      }
    }

    > div.img-box {
      margin-top: auto;
      width: 100%;
      max-height: 440px;
      text-align: center;
      overflow-y: auto;

      > img {
        width: 100%;
        cursor: pointer;
      }

      img + img {
        margin-top: 16px;
      }
    }

    iframe {
      width: 100%;
      height: 100%;
      border-radius: 30px;
    }
  }

  button {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 700;
    border: 0;
    background-color: #ECECEC;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

export const Chip = styled.p`
  width: fit-content;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 20px;
  font-weight: 700;
  background-color: #F4F6FB;
  border-radius: 4px;
`;
